// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"c29854af","72":"73d791b3","192":"fd66846e","231":"82fe84e9","353":"a142dc76","511":"308f016b","628":"bfaeb790","689":"b5ce6614"}[chunkId] + ".chunk.js";
};